import type { R2Bandwidth } from '../../../lib/types';

export function bandwidthValue(
    metric: R2Bandwidth | undefined,
    direction: 'uploaded_bytes' | 'downloaded_bytes'
): string {
    const bytes = metric?.[direction];
    if (
        metric?.source !== 'cloudflare_r2_bandwidth_adaptive' ||
        metric.unit !== 'bytes' ||
        !['fresh', 'stale'].includes(metric.status) ||
        typeof bytes !== 'number' ||
        !Number.isSafeInteger(bytes) ||
        bytes < 0
    )
        return 'Unavailable';
    const suffix = metric.status === 'stale' ? ' (stale)' : '';
    if (bytes === 0) return `0 B${suffix}`;
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const index = Math.min(Math.floor(Math.log10(bytes) / 3), units.length - 1);
    return `${(bytes / 1000 ** index).toLocaleString('en-US', { maximumFractionDigits: 2 })} ${units[index]}${suffix}`;
}

export function bandwidthWindow(metric: R2Bandwidth | undefined): string {
    const start = Date.parse(metric?.window_start || '');
    const end = Date.parse(metric?.window_end || '');
    if (!Number.isFinite(start) || !Number.isFinite(end) || start >= end)
        return 'Window unavailable';
    return `${new Date(start).toISOString()} to ${new Date(end).toISOString()}`;
}
